'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  workerPath: '{{JSNETWORKX_BUNDLE}}'
};
module.exports = exports['default'];